import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { HttpClient, HttpResponse, HttpRequest, HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { of } from 'rxjs/observable/of';
import { catchError, last, map, tap } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AuthenticationService } from '../../authentication/authentication.service';
//import { SpinnerComponent } from '../../spinner.component';

@Component({
      selector: 'app-uploadview',
      templateUrl: './uploadview.component.html',
      styleUrls: ['./uploadview.component.css']
})
export class UploadviewComponent implements OnInit {

      /** Link text */
      @Input() text = 'Upload';
      /** Name used in form which will be sent in HTTP request. */
      @Input() value = '';
      @Input() field = '';
      @Input() value1 = '';
      @Input() field1 = '';
      @Input() value2 = '';
      @Input() field2 = '';
      @Input() value3 = '';
      @Input() field3 = '';
      @Input() value4 = '';
      @Input() field4 = '';
      @Input() replaceId: number | string = '';
      @Input() upload_title = "Upload File";
      /** Target URL for file uploading. */
      @Input() target = 'http://192.168.88.9:3010/fileupload';
      /** File extension that accepted, same as 'accept' of <input type="file" />. 
          By the default, it's set to 'image/*'. */
      @Input() accept = [];
      /** Allow you to add handler after its completion. Bubble up response text from remote. */
      @Output() complete = new EventEmitter<string>();

      public files: Array<FileUploadModel> = [];
      public state = false;
      public dialogRef: MatDialogRef<unknown, any>;
      public submitted:boolean = false
      public countryname = 'USA'

      constructor(private _http: HttpClient, public dialog: MatDialog, protected msg: MatSnackBar, public Auth: AuthenticationService) {
      }

      ngOnInit() {}


      onClick() {
            const fileUpload = document.getElementById('filename') as HTMLInputElement;

            fileUpload.onchange = () => {
                  for (let index = 0; index < fileUpload.files.length; index++) {
                        const file = fileUpload.files[index];
                        this.files.push({ data: file, state: 'in', inProgress: false, progress: 0, canRetry: false, canCancel: true });
                  }
                  this.uploadFiles();
                  this.dialogRef.close();
            }
            fileUpload.click();
            this.files = [];
      }

      cancelFile(file: FileUploadModel) {
            file.sub.unsubscribe();
            this.removeFileFromArray(file);
      }

      retryFile(file: FileUploadModel) {
            this.uploadFile(file);
            file.canRetry = false;
      }

      readFile(fileEvent: any) {
            const file = fileEvent[0];
            let _status: boolean = false;
            if (file.size > 0) {
                  if (this.accept.length > 0) {
                        this.accept.forEach(ele => {
                              if (ele == file.type) {
                                    _status = true;
                              }
                        });
                  } else {
                        _status = true;
                  }
                  if (!_status) {
                        this.msg.open('File type is not allowd. Please upload valid file.', 'Clear', { duration: 3000 });
                  }
                  return _status;
            } else {
                  this.msg.open('File have no size', 'Clear', { duration: 3000 });
                  return false;
            }
      }

      private uploadFile(file: FileUploadModel) {
            if (sessionStorage.getItem('dummy') == '1') {
                  this.Auth.remove_Sample().subscribe((res: any) => {
                        console.log(res);
                        if (res.status == 200) {
                              // this.sampledata=false
                              sessionStorage.removeItem("sample_data")
                        }
                  })
            }
            this.state = true;
            const fd = new FormData();
            fd.append("filename", file.data);
            fd.append(this.field, JSON.stringify(this.value));
            fd.append("id_user", sessionStorage.getItem('iduser'));
            fd.append("id_campaign", this.field);
            fd.append(this.field1, this.value1);
            if (this.field2) {
                  fd.append(this.field2, this.value2);
            } else {
                  fd.append('leadtype', this.value2);
            }
            if (this.field3) {
                  fd.append(this.field3, this.value3);
            }
            if (this.field4) {
                  fd.append(this.field4, JSON.stringify(this.value4));
            }
            fd.append('country', this.countryname);
            if (this.replaceId !== undefined && this.replaceId !== null && this.replaceId !== '') {
              fd.append('replace_id', String(this.replaceId));
            }

            const req = new HttpRequest('POST', this.target, fd, {
                  reportProgress: true
            });
            file.inProgress = true;
            file.sub = this._http.request(req).pipe(
                  map(event => {
                        switch (event.type) {
                              case HttpEventType.UploadProgress:
                                    file.progress = Math.round(event.loaded * 100 / event.total);

                                    break;
                              case HttpEventType.Response:
                                    {
                                          return event;
                                    }
                        }
                  }),
                  tap(message => { }),
                  last(),
                  catchError((error: HttpErrorResponse) => {
                        file.inProgress = false;
                        file.canRetry = true;
                        return of(`${file.data.name} upload failed.`);
                  })
            ).subscribe(
                  (event: any) => {
                        this.complete.emit(event.body);
                        this.state = false;
                  }
            );
      }

      private uploadFiles() {
            const fileUpload = document.getElementById('filename') as HTMLInputElement;
            fileUpload.value = '';
            this.files.forEach(file => {
                  var event = this.uploadFile(file);
            });
      }

      private removeFileFromArray(file: FileUploadModel) {
            const index = this.files.indexOf(file);
            if (index > -1) {
                  this.files.splice(index, 1);
            }
      }


}

export class FileUploadModel {
      data: File;
      state: string;
      inProgress: boolean;
      progress: number;
      canRetry: boolean;
      canCancel: boolean;
      sub?: Subscription;
}